import React from 'react';
import Paragraph from "@scentregroup/ui/components/paragraph";
import ExternalLink from '../../external-link';
import style from './index.module.scss';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const MovieProviderBanner = _ref => {
  let {
    flicksLink
  } = _ref;
  const urlIndex = 'https://www.'.length;
  const formatFlicksDomain = flicksLink.substring(urlIndex).split('/', 1);
  return /*#__PURE__*/_jsx(ExternalLink, {
    url: flicksLink,
    "data-id": "movie-provider-banner_index_MovieProviderBanner_ExternalLink",
    children: /*#__PURE__*/_jsxs(Paragraph, {
      className: style.sponsorBlock,
      "data-id": "movie-provider-banner_index_MovieProviderBanner_ExternalLink_Paragraph",
      children: ["Content powered by ", formatFlicksDomain]
    })
  });
};
export default MovieProviderBanner;